"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _downshift = require("downshift");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../form/utils");

var _dropdownList = require("../helpers/dropdown-list");

var _useStatePlacement2 = require("../helpers/dropdown-list/useStatePlacement");

var _useIsomorphicLayoutEffect = require("../hooks/useIsomorphicLayoutEffect");

var _context = require("../context");

var _form = require("../form");

var _layout = require("../layout");

var _utils2 = require("../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _helpers = require("./helpers");

var _propTypes = require("./propTypes");

var _useCheckOpenState2 = require("./useCheckOpenState");

var _core = require("@emotion/core");

var _excluded = ["aria-describedby", "aria-invalid", "aria-required", "clearButtonAltText", "clearButtonRef", "disabled", "error", "hasSubmitButton", "id", "isLoading", "labelId", "listActionButtonText", "listMaxHeight", "listPositioningStrategy", "loadingErrorText", "loadingText", "name", "noResultsText", "onChange", "onListActionButtonClick", "onResultClick", "onSubmitClick", "placeholder", "query", "renderResult", "resultToString", "results", "resultCountText", "shouldAutocomplete", "shouldOpenOnClick", "shouldShowListOnNoResults", "submitButtonAltText", "virtualizedListProps", "warning", "width"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var flattenGroupOptions = function flattenGroupOptions(options) {
  return options.reduce(function (prev, curr) {
    return [].concat((0, _toConsumableArray2.default)(prev), (0, _toConsumableArray2.default)(curr.values));
  }, []);
};

var SearchFieldWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var ariaDescribedBy = _ref['aria-describedby'],
      ariaInvalid = _ref['aria-invalid'],
      ariaRequired = _ref['aria-required'],
      _ref$clearButtonAltTe = _ref.clearButtonAltText,
      clearButtonAltText = _ref$clearButtonAltTe === void 0 ? _constants.defaultProps.clearButtonAltText : _ref$clearButtonAltTe,
      _ref$clearButtonRef = _ref.clearButtonRef,
      clearButtonExternalRef = _ref$clearButtonRef === void 0 ? null : _ref$clearButtonRef,
      disabled = _ref.disabled,
      error = _ref.error,
      hasSubmitButton = _ref.hasSubmitButton,
      idProp = _ref.id,
      isLoading = _ref.isLoading,
      labelIdProp = _ref.labelId,
      _ref$listActionButton = _ref.listActionButtonText,
      listActionButtonText = _ref$listActionButton === void 0 ? _constants.defaultProps.listActionButtonText : _ref$listActionButton,
      listMaxHeight = _ref.listMaxHeight,
      listPositioningStrategy = _ref.listPositioningStrategy,
      loadingErrorText = _ref.loadingErrorText,
      _ref$loadingText = _ref.loadingText,
      loadingText = _ref$loadingText === void 0 ? _constants.defaultProps.loadingText : _ref$loadingText,
      name = _ref.name,
      _ref$noResultsText = _ref.noResultsText,
      noResultsText = _ref$noResultsText === void 0 ? _constants.defaultProps.noResultsText : _ref$noResultsText,
      onChange = _ref.onChange,
      onListActionButtonClick = _ref.onListActionButtonClick,
      onResultClick = _ref.onResultClick,
      onSubmitClick = _ref.onSubmitClick,
      placeholder = _ref.placeholder,
      query = _ref.query,
      renderResult = _ref.renderResult,
      _ref$resultToString = _ref.resultToString,
      resultToString = _ref$resultToString === void 0 ? _constants.defaultProps.resultToString : _ref$resultToString,
      _ref$results = _ref.results,
      results = _ref$results === void 0 ? [] : _ref$results,
      _ref$resultCountText = _ref.resultCountText,
      resultCountText = _ref$resultCountText === void 0 ? _constants.defaultProps.resultCountText : _ref$resultCountText,
      _ref$shouldAutocomple = _ref.shouldAutocomplete,
      shouldAutocomplete = _ref$shouldAutocomple === void 0 ? _constants.defaultProps.shouldAutocomplete : _ref$shouldAutocomple,
      _ref$shouldOpenOnClic = _ref.shouldOpenOnClick,
      shouldOpenOnClick = _ref$shouldOpenOnClic === void 0 ? _constants.defaultProps.shouldOpenOnClick : _ref$shouldOpenOnClic,
      _ref$shouldShowListOn = _ref.shouldShowListOnNoResults,
      shouldShowListOnNoResults = _ref$shouldShowListOn === void 0 ? _constants.defaultProps.shouldShowListOnNoResults : _ref$shouldShowListOn,
      submitButtonAltText = _ref.submitButtonAltText,
      virtualizedListProps = _ref.virtualizedListProps,
      warning = _ref.warning,
      width = _ref.width,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilDialogContext),
      setHasOpenedDialog = _useContext.setHasOpenedDialog;

  var componentId = (0, _react.useMemo)(function () {
    return "search-".concat((0, _utils2.getUniqueId)());
  }, []);
  var lastQuery = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var listActionButtonRef = (0, _react.useRef)(null);
  var clearButtonRef = (0, _react.useRef)(null);
  var id = !!idProp ? idProp : (0, _utils2.getUniqueId)('search-field-input');
  var labelId = labelIdProp || (0, _utils.buildLabelId)(id);
  var hasOptionGroups = (0, _helpers.isOptionGroupsAvailable)(results);
  var flattenResults = (0, _react.useMemo)(function () {
    return hasOptionGroups ? flattenGroupOptions(results) : results;
  }, [hasOptionGroups, results]);
  var resultsToDisplay = !!loadingErrorText ? [] : flattenResults;
  var defaultResultCountAnnouncement = resultCountText ? resultCountText : _constants.defaultProps.resultCountText; // downshift might call this with null in certain cases, but we abstract that
  // away from consumers since they shouldn't have to care about that.

  var resultToStringWithNullCheck = function resultToStringWithNullCheck(result) {
    return result ? resultToString(result) : '';
  }; // Last query needs to be stored, otherwise onChange gets called twice because
  // this function is called from two places
  // - useCombobox: For typing and selecting
  // - getInputProps: To fix caret movement https://t.corp.amazon.com/V371486331


  var handleInputChange = function handleInputChange() {
    var newQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (newQuery !== lastQuery.current) {
      onChange(newQuery);
    }

    lastQuery.current = newQuery;
  }; // if query changes externally update the last query value if it is different from query
  // https://t.corp.amazon.com/D62508602


  if (query !== undefined && query !== lastQuery.current) {
    lastQuery.current = query;
  }

  var _useCheckOpenState = (0, _useCheckOpenState2.useCheckOpenState)(results.length, shouldShowListOnNoResults, inputRef),
      getOpenStateValue = _useCheckOpenState.getOpenStateValue,
      onResultsChanges = _useCheckOpenState.onResultsChanges; // stateReducer (where this is using) is memoized and it is not getting fresh function
  // instead of passing it as a function itself, it needs to be passed as reference


  var getOpenStateValueRef = (0, _react.useRef)(getOpenStateValue);
  getOpenStateValueRef.current = getOpenStateValue; // We track Tab presses in order to manage when the search dropdown
  // should be opened/closed, which is decided inside the reducer.

  var isTabPressed = (0, _react.useRef)(false); // If shouldAutocomplete is false, don't set the query to the selected
  // search result when one is selected.

  var stateReducer = function stateReducer(state, updates) {
    var type = updates.type,
        changes = updates.changes;

    switch (type) {
      case _downshift.useCombobox.stateChangeTypes.InputBlur:
        var shouldDropdownStayOpen = false;
        var shouldSelectValue = shouldAutocomplete;
        var inputValue = shouldSelectValue ? changes.inputValue : undefined; // Keep dropdown open if a list action button is present.

        if (onListActionButtonClick && listActionButtonRef.current && isTabPressed.current) {
          shouldDropdownStayOpen = true;
        } // Clean the tab press ref so that clicking outside the dropdown
        // closes the dropdown.


        isTabPressed.current = false;
        return _objectSpread(_objectSpread({}, changes), {}, {
          inputValue: inputValue,
          isOpen: shouldDropdownStayOpen
        });

      case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
      case _downshift.useCombobox.stateChangeTypes.ItemClick:
        // Simulate selecting the highlighted item. onSelectedItemChange
        // cannot be used for this because it doesn't fire if the same
        // item is chosen twice in a row
        if (state.highlightedIndex > -1 && resultsToDisplay.length > 0) {
          if (!!onResultClick) {
            // Calling onResultClick function in setTimeout to execute it after states changes
            setTimeout(function () {
              if (hasOptionGroups) {
                onResultClick(resultsToDisplay[state.highlightedIndex]);
              } else {
                onResultClick(results[state.highlightedIndex]);
              }
            }, 0);
          }
        }

        return shouldAutocomplete ? changes : _objectSpread(_objectSpread({}, changes), {}, {
          inputValue: state.inputValue
        });

      case _downshift.useCombobox.stateChangeTypes.InputKeyDownEscape:
        return _objectSpread(_objectSpread({}, changes), {}, {
          inputValue: ''
        });

      default:
        return _objectSpread(_objectSpread({}, changes), {}, {
          isOpen: getOpenStateValueRef.current(!!changes.isOpen)
        });
    }
  };

  var onIsOpenChange = function onIsOpenChange(changes) {
    setHasOpenedDialog(!!changes.isOpen);
  };

  var resultsCount = resultsToDisplay.length;

  var _useCombobox = (0, _downshift.useCombobox)({
    items: resultsToDisplay,
    itemToString: resultToStringWithNullCheck,
    inputValue: query,
    onInputValueChange: function onInputValueChange(_ref2) {
      var inputValue = _ref2.inputValue;
      handleInputChange(inputValue);
    },
    id: id,
    labelId: labelId,
    stateReducer: stateReducer,
    onIsOpenChange: onIsOpenChange,
    // Prevent downshift from announcing when results are found.
    // Wrong announcement is made when results are fetched async.
    getA11yStatusMessage: function getA11yStatusMessage() {
      return '';
    },
    // Prevent downshift from announcing when a result is selected.
    // Wrong announcement is made when focusing on an item and pressing Tab.
    getA11ySelectionMessage: function getA11ySelectionMessage() {
      return '';
    }
  }),
      getComboboxProps = _useCombobox.getComboboxProps,
      getInputProps = _useCombobox.getInputProps,
      getMenuProps = _useCombobox.getMenuProps,
      getItemProps = _useCombobox.getItemProps,
      isOpen = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      openMenu = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu,
      reset = _useCombobox.reset;

  var dataProps = (0, _utils2.pickDataProps)(forwardedProps);
  var dropdownId = getMenuProps().id;

  var focusSearchInput = function focusSearchInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var handleClearButtonClick = function handleClearButtonClick() {
    reset();
    focusSearchInput();
  };

  var focusClearButton = function focusClearButton(event) {
    if (clearButtonRef && clearButtonRef.current) {
      event.preventDefault(); // Prevent Downshift's default behavior. Without this line,
      // pressing Enter/Tab will not select the highlighted element.

      event.nativeEvent.preventDownshiftDefault = true;
      clearButtonRef.current.focus();
    }
  };

  var focusListActionButton = function focusListActionButton(event) {
    event.preventDefault();
    event.nativeEvent.preventDownshiftDefault = true;

    if (listActionButtonRef && listActionButtonRef.current) {
      listActionButtonRef.current.focus();
    }
  };

  var announcement = (0, _react.useMemo)(function () {
    if (!isOpen) {
      return '';
    }

    if (loadingErrorText) {
      return loadingErrorText;
    }

    if (!isLoading && results.length === 0 && shouldShowListOnNoResults) {
      return noResultsText;
    }

    if (!isLoading && results.length > 0) {
      return defaultResultCountAnnouncement(resultsCount);
    }

    return '';
  }, [loadingErrorText, noResultsText, isOpen, isLoading, results, defaultResultCountAnnouncement, shouldShowListOnNoResults, resultsCount]);
  var header = resultCountText ? (0, _core.jsx)(_helperComponents.SearchResultCountIndicator, {
    resultsCount: resultCountText(resultsCount)
  }) : null;

  if (!!loadingErrorText) {
    header = (0, _core.jsx)(_helperComponents.SearchErrorIndicator, {
      loadingErrorText: loadingErrorText
    });
  } else if (isLoading) {
    header = (0, _core.jsx)(_helperComponents.SearchLoadingIndicator, {
      loadingText: loadingText
    });
  } else if (!results.length) {
    header = (0, _core.jsx)(_helperComponents.SearchNoResultsIndicator, {
      noResultsText: noResultsText
    });
  } else if (onListActionButtonClick) {
    header = resultCountText && (0, _core.jsx)(_layout.Row, {
      alignItems: "center",
      justifyContent: "space-between"
    }, (0, _core.jsx)(_helperComponents.SearchResultCountIndicator, {
      resultsCount: resultCountText(results.length)
    }), (0, _core.jsx)(_helperComponents.SearchListActionButtonIndicator, {
      handleListActionButtonClick: function handleListActionButtonClick() {
        closeMenu();

        if (onListActionButtonClick) {
          onListActionButtonClick();
        }
      },
      handleListActionButtonTab: function handleListActionButtonTab(event) {
        if (event.key === _utils2.EventKeys.TAB) {
          closeMenu();
          focusClearButton(event);
        }
      },
      labelId: labelId,
      listActionButtonRef: listActionButtonRef,
      listActionButtonText: listActionButtonText
    }));
  }

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    onResultsChanges(isOpen, openMenu);
  }, [onResultsChanges, isOpen, openMenu]);
  var getComboboxPropsOptions = {
    'aria-expanded': isOpen && results.length > 0 && !isLoading && !loadingErrorText,
    'aria-haspopup': undefined,
    'aria-owns': undefined,
    ref: undefined
  };
  var getInputPropsOptions = {
    onChange: function onChange(event) {
      handleInputChange(event.target.value);
    },
    onClick: shouldOpenOnClick ? openMenu : undefined,
    onKeyDown: function onKeyDown(event) {
      if (event.key === _utils2.EventKeys.HOME || event.key === _utils2.EventKeys.END || // Native behavior on Enter keypress if no query or option highlighted.
      // If there's any highlighted option Enter keypress should set input state.
      !!query && highlightedIndex === -1 && event.key === _utils2.EventKeys.ENTER) {
        // Prevent Downshift's default Home/End behavior: https://github.com/downshift-js/downshift/issues/1162
        event.nativeEvent.preventDownshiftDefault = true;
      } // If dropdown is open


      if (isOpen) {
        isTabPressed.current = event.key === _utils2.EventKeys.TAB; // If an element has NOT been selected (no pseudofocus)

        if (highlightedIndex === -1) {
          if (event.key === _utils2.EventKeys.TAB) {
            // If there are no results - there is no list action button, move focus to clear
            if (results.length === 0) {
              focusClearButton(event);
            } // Else, focus on the list action button (if available)
            else if (onListActionButtonClick) {
              focusListActionButton(event);
            }
          }
        } // Else, if an element has been selected (highlighted with pseudofocus)
        else {
          if (event.key === _utils2.EventKeys.ENTER) {
            focusSearchInput();
          } else if (event.key === _utils2.EventKeys.TAB) {
            // If there is a list action button (if available)
            if (onListActionButtonClick) {
              focusListActionButton(event);
            } else {
              focusClearButton(event);
            }
          }
        }
      }
    },
    ref: (0, _utils2.mergeRefs)(inputRef, externalRef)
  };
  var insetElementLeading = (0, _helpers.renderInsetElementLeading)({
    disabled: disabled,
    hasSubmitButton: hasSubmitButton
  });
  var insetElementTrailing = (0, _helpers.renderInsetElementTrailing)({
    clearButtonAltText: clearButtonAltText,
    clearButtonRef: (0, _utils2.mergeRefs)(clearButtonRef, clearButtonExternalRef),
    disabled: disabled,
    handleClearButtonClick: handleClearButtonClick,
    hasSubmitButton: hasSubmitButton,
    onSubmitClick: onSubmitClick,
    query: query,
    submitButtonAltText: submitButtonAltText
  });

  var _useStatePlacement = (0, _useStatePlacement2.useStatePlacement)(isOpen),
      searchBorderRadius = _useStatePlacement.inputProps,
      listBorderRadius = _useStatePlacement.listProps,
      onPlacementChange = _useStatePlacement.onPlacementChange;

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.View, (0, _extends2.default)({}, dataProps, {
    width: width
  }), (0, _core.jsx)(_form.Input, (0, _extends2.default)({
    type: "text"
  }, getComboboxProps(getComboboxPropsOptions, {
    suppressRefError: true
  }), getInputProps(getInputPropsOptions, {
    suppressRefError: true
  }), {
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": ariaInvalid // Remove Downshift's default aria-labelledby which is not needed
    ,
    "aria-labelledby": null,
    "aria-required": ariaRequired,
    "aria-owns": dropdownId,
    dataTestComponent: "StencilSearchFieldInput",
    disabled: disabled,
    error: error,
    id: id,
    insetElementLeading: insetElementLeading,
    insetElementTrailing: insetElementTrailing,
    name: name,
    placeholder: placeholder,
    warning: warning,
    width: "100%"
  }, (0, _utils2.omitDataProps)(forwardedProps), searchBorderRadius)), (0, _core.jsx)(_dropdownList.DropdownList, (0, _extends2.default)({}, listBorderRadius, {
    componentId: componentId,
    dataTestComponent: "StencilSearchFieldResults",
    getItemProps: getItemProps,
    getListProps: getMenuProps,
    hasOptionGroups: hasOptionGroups,
    header: header,
    highlightedIndex: highlightedIndex,
    isOpen: getOpenStateValue(isOpen),
    itemToString: resultToStringWithNullCheck,
    items: isLoading ? [] : results,
    labelId: labelId,
    listMaxHeight: listMaxHeight,
    listPositioningStrategy: listPositioningStrategy,
    onPlacementChange: onPlacementChange,
    renderItem: renderResult,
    selectedItems: highlightedIndex > -1 ? [results[highlightedIndex]] : undefined,
    target: inputRef,
    virtualizedListProps: virtualizedListProps
  }))), (0, _core.jsx)(_helperComponents.MemoisedLiveRegion, {
    announcement: announcement
  }));
});
var SearchFieldWithDocs = (0, _stencilReactDesc.describe)(SearchFieldWithoutDocs).description('Search field that shows results as a dropdown.');
SearchFieldWithDocs.propTypes = _objectSpread({}, _propTypes.searchPropTypes);
SearchFieldWithDocs.defaultProps = _objectSpread({}, _constants.defaultProps);
var SearchField = (0, _utils2.withTestAttributes)({
  component: 'StencilSearchField'
})(SearchFieldWithDocs);
SearchField.displayName = 'SearchField';
var _default = SearchField;
exports.default = _default;